if($('.type-detail').length){
    $('.stars-label').each(function() {
        var text = $(this).text();
        if (text.indexOf('(Již jste hlasovali)') !== -1) {
            $(this).text(text.replace('(Již jste hlasovali)', ''));
        }
    });
    $('.parameter-dependent').each(function(){
        if($(this).text().trim() === 'Zvolte variantu'){
            $(this).text('Dle varianty')
        }
    })
    $('.p-image').append($('.product-top .col-xs-12:not(.col-lg-6) .flags-default').clone())
    $('.p-info-wrapper .delivery-time').closest('tr').hide()
    $('.p-info-wrapper').append('<div class="stockLine"></div>')
    $('.stockLine').append($('.p-info-wrapper .availability-value'))
    $('.stockLine').append($('.p-info-wrapper .delivery-time').closest('th').html())
    $('.p-info-wrapper').append('<div class="customCart"><div class="inner"><span class="btn_toggle"></span></div></div>')
    $('.customCart .inner').prepend($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'))
    $('.p-info-wrapper').append($('.p-detail .p-detail-inner .p-detail-inner-header').clone(), $('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info').clone())
    if ($('.extended-description .detail-parameters tr th:contains("#Inspirace")').length > 0) {
        // Načteme text obsahující JSON
        $('.p-detail-inner').after('<div class="superInspiration"><div class="h4 homepage-group-title">Outfity inspirované tímto produktem</div></div>')
        var jsonText = $('.extended-description .detail-parameters tr th:contains("#Inspirace")').closest('tr').find('td').text();
       
        if (jsonText) {
            $.ajax({
                url: jsonText,
                type: 'GET',
                dataType: 'json',
                success: function(response) {
                    localStorage.setItem('inspiratorData', JSON.stringify(response));
                    processInspiratorData(response);
                },
                error: function(xhr, status, error) {
                    console.error("Error fetching data:", status, error);
                }
            });
        } else {
            var storedData = localStorage.getItem('inspiratorData');
            if (storedData) {
                var parsedData = JSON.parse(storedData);
                processInspiratorData(parsedData);
            }
        }
        function processInspiratorData(data) {
            var itemCount = data.length;
            data.forEach(function(item, index) {
              
                var itemImage = item.url
                if(itemImage.includes('/www/')){
                    itemImageNew = itemImage
                }
                else{
                    itemImage = itemImage.split('/upload/')[1]
                    itemImageNew = 'https://inspirator.shopcode.cz/www/upload/'+itemImage
                }

                var itemClass = '';
                if (itemCount === 1) {
                    itemClass = 'full'; // Pokud je jedna položka, bude mít třídu full
                } else if (itemCount === 2) {
                    itemClass = 'half'; // Pokud jsou dvě položky, obě dostanou třídu half
                } else if (itemCount === 3) {
                    // Pokud jsou tři položky, první dva dostanou jednu třídu, poslední jinou
                    itemClass = (index < 2) ? 'third' : 'two-thirds';
                }

                var itemHtml = '<div class="itemInner '+itemClass+'">';
                itemHtml += '<img src="' +itemImageNew+ '" alt="Image">';
                itemHtml += '<div class="points">';
                item.points.forEach(function(point) {
                    itemHtml += '<div class="point" style="top:' + point.top + '%; left:' + point.left + '%;">';
                        itemHtml += '<span class="pointCircle"></span>'
                        itemHtml += '<div class="description" style="display:none;">'
                            itemHtml += '<div class="descriptionInner">'
                                itemHtml += '<span class="close"></span>'
                                itemHtml += '<div class="image"><img src="' + point.product.image + '" alt="' + point.product.name + '"></div>'
                                itemHtml += '<div class="right">'
                                    itemHtml += '<span class="title"><a href="' + point.product.url + '">' + point.product.name + '</a></span>'
                                    itemHtml += '<div class="prices">'
                                        if(point.product.actionPrice !== 0){
                                            itemHtml += '<span class="Actionprice">'+Number(point.product.price).ShoptetFormatAsCurrency()+'</span>'
                                            itemHtml += '<span class="price">'+Number(point.product.actionPrice).ShoptetFormatAsCurrency()+'</span>'
                                        }
                                        else{
                                            itemHtml += '<span class="price">'+Number(point.product.price).ShoptetFormatAsCurrency()+'</span>'
                                        }
                                    
                                    itemHtml += '</div>'
                                    itemHtml += '<div class="text-center"><a href="'+ point.product.url +'" class="btn btn-primary">Detail</a></div>'
                                itemHtml += '</div>';
                            itemHtml += '</div>';
                        itemHtml += '</div>';
                    itemHtml += '</div>';
                });
                itemHtml += '</div></div>';
                $('.superInspiration').append(itemHtml);
            });
        }
        $(document).on('click', '.point .pointCircle', function() {
            var $currentPoint = $(this).closest('.point');
            $('.point').not($currentPoint).each(function() {
                var $otherPoint = $(this);
                if ($otherPoint.hasClass('openPoint')) {
                    $otherPoint.removeClass('openPoint');
                    $otherPoint.find('.description').slideUp(500);
                }
            });
            $currentPoint.toggleClass('openPoint');
            $currentPoint.find('.description').slideToggle(500);
        });
        $(document).on('click', '.point .close', function(){
            $(this).closest('.point').find('.description').slideToggle(500)
            $(this).closest('.point').toggleClass('openPoint')
        })
    }
    
    
    
    
    if($('.basic-description').length){
        if($('.extended-description').length){
            if($('.extended-description .detail-parameters tr th:contains("#Modelka:")').length>0){
                $('.extended-description .detail-parameters tr th:contains("#Modelka:")').closest('tr').hide();
                $('.p-info-wrapper').append('<div class="modelka">'+$('.extended-description .detail-parameters tr th:contains("#Modelka:")').closest('tr').find('td').text()+'</div>');

            }

            if($('.extended-description .detail-parameters tr th:contains("#Průvodce velikostmi:")').length>0){
                $('.extended-description .detail-parameters tr th:contains("#Průvodce velikostmi:")').closest('tr').hide();
                $('.p-info-wrapper').append('<div class="sizeguid"><span class="chooseSizes" data-url="'+$('.extended-description .detail-parameters tr th:contains("#Průvodce velikostmi:")').closest('tr').find('td').text()+'">Průvodce velikostmi</span></div>');

            }
            if($('.extended-description .detail-parameters tr th:contains("Tipy od Zuzky:")').length>0){
                $('.extended-description .detail-parameters tr th:contains("Tipy od Zuzky:")').closest('tr').hide();
                $('.p-info-wrapper').append('<div class="tipOdZuzky"><h3>Tip od Zuzky</h3>'+$('.extended-description .detail-parameters tr th:contains("Tipy od Zuzky:")').closest('tr').find('td').text()+'</div>');

            }
            if($('.extended-description .detail-parameters tr th:contains("#Údržba")').length>0){
               $('.extended-description .detail-parameters tr th:contains("Údržba:")').closest('tr').hide();
                $('.p-info-wrapper').append('<div class="customTab" data-section="udrzba"><span class="title">Údržba</span><div class="customTabBottom" style="diplay:none;"><div class="udrzbaFeed"></div></div>')
                $('.extended-description .detail-parameters tr th:contains("Údržba:")').closest('tr').find('td').text().trim().split('|').forEach(function(item) {
                    let className = removeDiacritics(item.toLowerCase().replace(/\s+/g, '-').replace('°', ''));
                    $('[data-section="udrzba"] .customTabBottom .udrzbaFeed').append('<div class="'+className+'"><div class="image"><img src="/user/documents/upload/udrzba/'+className+'.svg" alt="'+item+'"></div></div>');
                });
            }
            if($('.extended-description .detail-parameters tr th:contains("#Dostupnosti")').length>0){
                $('.extended-description .detail-parameters tr th:contains("Dostupnosti:")').closest('tr').hide();
                $('.p-info-wrapper').append('<div class="customTab" data-section="dostupnosti"><span class="title" data-url="'+$('.extended-description .detail-parameters tr th:contains("#Dostupnosti")').closest('tr').find('td').text()+'">Dostupnosti</span><div class="customTabBottom" style="diplay:none;"></div></div>')
            }
            $('.extended-description .detail-parameters tr th:contains("Další barvy")').each(function() {
                let $this = $(this).closest('tr');
                $this.hide();
                $('.p-info-wrapper').append('<div class="friends"><div class="h4">Další barevná provedení:</div><div class="feed"></div></div>')
                let codes = [];
                $this.find('td').each(function() {
                    let codeArray = $(this).text().split(',');
                    codeArray.forEach(function(code) {
                        code = code.trim();
                        if (!codes.includes(code)) {
                            codes.push(code);
                        }
                    });
                });
            
                if (codes.length > 0) {
                    let endpoint = 'https://node-7183.rostiapp.cz/api/zannia/products?codes=' + codes.join(',');
                    $.get(endpoint, function(data) {
                        let productData = data;
                        let currentProduct = {
                            NAME: $('.breadcrumbs>span').last().text().trim(),
                            CLEAR_NAME: $('.breadcrumbs>span').last().text().trim(),
                            URL: window.location.href,
                            IMG_URL: $('.p-thumbnails-inner a').first().attr('href'),
                            isCurrent: true
                        };
                        productData.unshift(currentProduct);
                        productData.sort(function(a, b) {
                            return a.CLEAR_NAME.localeCompare(b.CLEAR_NAME);
                        });
                        function getVariantDeclension(count) {
                            let lastDigit = count % 10;
                            let lastTwoDigits = count % 100;
                            if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
                                return 'barevných variant';
                            } else if (lastDigit === 1) {
                                return 'barevná varianta';
                            } else if (lastDigit >= 2 && lastDigit <= 4) {
                                return 'barevné varianty';
                            } else {
                                return 'barevných variant';
                            }
                        }

                        if (productData.length > 4) {
                            productData.slice(0, 3).forEach(function(product) {
                                let customProductData = '<div class="friendProduct show-tooltip ' + (product.isCurrent ? 'current-product' : '') + '" title="' + product.CLEAR_NAME + '" data-original-title="' + product.CLEAR_NAME + '">';
                                customProductData += '<div class="p">';
                                customProductData += '<a href="' + product.URL.split('/?variantId')[0] + '" class="image">';
                                customProductData += '<img src="' + product.IMG_URL.replace('/orig/', '/big/') + '" alt="' + product.CLEAR_NAME + '">';
                                customProductData += '</a>';
                                customProductData += '</div>';
                                customProductData += '</div>';
                                $('.friends .feed').append(customProductData);
                            });
                            let remainingCount = productData.length - 3;
                            if (remainingCount > 0) {
                                let declension = getVariantDeclension(remainingCount);
                                let remainingDiv = '<div class="remainingVariants"><span>+' + remainingCount + ' <br>' + declension + '</span></div>';
                                $('.friends .feed').append(remainingDiv);
                                $('.remainingVariants').on('click', function() {
                                    productData.slice(3).forEach(function(product) {
                                        let customProductData = '<div class="friendProduct show-tooltip ' + (product.isCurrent ? 'current-product' : '') + '" title="' + product.CLEAR_NAME + '" data-original-title="' + product.CLEAR_NAME + '">';
                                        customProductData += '<div class="p">';
                                        customProductData += '<a href="' + product.URL.split('/?variantId')[0] + '" class="image">';
                                        customProductData += '<img src="' + product.IMG_URL.replace('/orig/', '/big/') + '" alt="' + product.CLEAR_NAME + '">';
                                        customProductData += '</a>';
                                        customProductData += '</div>';
                                        customProductData += '</div>';
                                        $('.friends .feed').append(customProductData);
                                    });
                                    $(this).remove();
                                    initTooltips();
                                });
                            }
                        } else {
                            productData.forEach(function(product) {
                                let customProductData = '<div class="friendProduct show-tooltip ' + (product.isCurrent ? 'current-product' : '') + '" title="' + product.CLEAR_NAME + '" data-original-title="' + product.CLEAR_NAME + '">';
                                customProductData += '<div class="p">';
                                customProductData += '<a href="' + product.URL.split('/?variantId')[0] + '" class="image">';
                                customProductData += '<img src="' + product.IMG_URL.replace('/orig/', '/big/') + '" alt="' + product.CLEAR_NAME + '">';
                                customProductData += '</a>';
                                customProductData += '</div>';
                                customProductData += '</div>';
                                $('.friends .feed').append(customProductData);
                            });
                        }
                    })
                    .done(function(){
                        initTooltips();
                    })
                }
            });
            

            $('.p-info-wrapper').append('<div class="customTab" data-section="parameters"><span class="title">Parametry produktu</span><div class="customTabBottom" style="diplay:none;">'+$('.extended-description').html()+'</div></div>')
        
        
        }

        $('.p-info-wrapper').append('<div class="customTab" data-section="description"><span class="title">Popis produktu</span><div class="customTabBottom" style="diplay:none;">'+$('.basic-description').html()+'</div></div>')
        $('#tab-content #description').remove()

        $('html').on('click', '.customTab .title', function(){
            let url = $(this).attr('data-url');
            let $thisElement = $(this)
            if (url) {
                $.get(url, function(data) {
                    $thisElement.closest('.customTab').find('.customTabBottom').html($(data).find('div[itemprop="about"]').html().trim());
                }).fail(function() {
                    $thisElement.closest('.customTab').find('.customTabBottom').html('<p>Chyba při načítání obsahu, zkuste prosím obnovit stránku</p>');
                });
            }
            $(this).toggleClass('haveOpen')
            $(this).closest('.customTab').find('.customTabBottom').slideToggle()
        })
    }

    if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
        
        $('.p-image-wrapper').addClass('haveThumbnails')
        $('.p-image-wrapper').append('<span class="arrow-prev"></span><span class="arrow-next"></span>');
    
        $('body').on('click', '.arrow-prev, .arrow-next', function () {
        
            var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
            var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
            var isNext = $(this).hasClass('arrow-next');
            var totalThumbnails = thumbnails.length;
            var currentIndex = thumbnails.index(highlightedThumbnail);
            thumbnails.removeClass('highlighted');
            if (highlightedThumbnail.length === 0) {
                highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
            } else {
                currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
                highlightedThumbnail = thumbnails.eq(currentIndex);
            }
            highlightedThumbnail.addClass('highlighted');
            setTimeout(function () {
                updateMainImage(highlightedThumbnail);
            }, 10);
        });
      
       
    
    }

    function updateMainImage(highlightedThumbnail) {
        var findHighlighted = highlightedThumbnail.attr('href');
        var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
        $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
    }

    if ($('.p-thumbnail').length) {
       /* $('.p-thumbnail img').each(function(){
            $(this).attr('data-src', $(this).attr('data-src').replace('/related/', '/orig/'))
        })*/
        let totalThumbnails = $('.p-thumbnail').length;
        if (totalThumbnails > 6) {
            let remaining = totalThumbnails - 6;
            function correctForm(number) {
                if (number === 1) {
                    return 'fotografie';
                } else if (number >= 2 && number <= 4) {
                    return 'fotografie';
                } else {
                    return 'fotografií';
                }
            }
    
            let correctText = '+ ' + remaining + ' ' + correctForm(remaining);
            $('.p-thumbnail').eq(6).addClass('haveThumb').append('<span class="text">'+correctText+'</span>');
        }
    }

    $('html').on('click', '.p-thumbnail', (function(){
        $('.cbox-gal[href="'+$(this).attr("href")+'"]').attr('href', $(this).attr("href")).trigger('click')
    }));
    
    $(document).ready(function () {
        if(sessionStorage.homepageBanners) {
          $('.detailImport').append(sessionStorage.homepageBanners);
        } else {
          $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e);
                    var suitUpHtml = $(a).find(".suitUp").closest('span').html();
                    var storesHtml = $(a).find(".stores").closest('span').html();
                    var calendarHtml = $(a).find(".calendarAndAction").closest('span').html();
                    if (suitUpHtml !== null) {
                        $(".detailImport").append(suitUpHtml);
                    }
                    if (storesHtml !== null) {
                        $(".detailImport").append(storesHtml);
                        $('.storeLine .left').slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: false,
                            autoplay: false,
                            autoplaySpeed: 5000,
                            dots: false,
                            arrows: true,
                            infinite: false,
                            adaptiveHeight: true,
                            responsive: [
                              {
                                breakpoint: 767,
                                settings: {
                                 slidesToShow: 1,
                                 slidesToScroll: 1,
                                 dots: true,
                                arrows: false,
                               }
                               
                              } 
                            ]
                        });
                    }
                    if (calendarHtml !== null) {
                        $(".detailImport").append(calendarHtml);
                    }
                    sessionStorage.homepageBanners = $(".detailImport").html();
                }
          });
        }           
    })



    if(!$('#simple-variants').length){
        if($('.variant-list, .surcharge-list').length>0){
            $('.variant-list select, .surcharge-list select').each(function(){
                if($(this).closest('.surcharge-list').find('th .show-tooltip').length){
                    var listTootip = $(this).closest('.surcharge-list').find('th .show-tooltip').attr('title')
                }
                else{
                    listTootip = ''
                }
                var optionLength = $(this).find('option').length
                var data_parameter_id = $(this).data('parameter-id')
                var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
                html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
                $(this).find('option').each(function(){
                    var data_value = $(this).attr('value')
                    if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="text">'
                            if(typeof textsplit[1] === 'undefined'){
                                html_var += textsplit[0]
                            }
                            else{
                                html_var += textsplit[0]+' (+'+textsplit[1]+')'
                            }
                          
                            if(listTootip !== ''){
                                if(textsplit[1] !== '0 Kč'){
                                    html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                                }
                            }
                            html_var += '</div>'
                            html_var += '</div>'
                        }
                    }
                    else{
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveSurcharge show-tooltip" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/'+data_value+'.svg?v='+new Date().getMinutes()+'" alt="'+$(this).text()+'"></div>'
                            html_var += '</div>'
                        }
                    }
                    
                })
                html_var += '</div>'
                html_var += '</div>'
                $(this).after(html_var)
                $(this).closest('.variant-list select, .surcharge-list select').hide()
               $(this).closest('.variant-list span, .surcharge-list span').hide()
              
            })
    
            var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
            for (var parentKey in necessaryVariantData) {
                if (necessaryVariantData.hasOwnProperty(parentKey)) {
                    var variant = necessaryVariantData[parentKey];
                    $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
                
                }
            }
            
        }
    }
    

    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
    
        // Změna pro data-parameter-id 281 a třídu active
        if($(this).attr('data-parameter-id') === '281' && $(this).hasClass('active')){
            $("select[data-parameter-id='281'] option:first").prop("selected", true).change();
            $(this).removeClass("active"); 
        }
        else if($(this).attr('data-parameter-id') === '379' && $(this).hasClass('active')){
            $("select[data-parameter-id='379'] option:first").prop("selected", true).change();
            $(this).removeClass("active"); 
        } else {
            // Původní chování pro ostatní případy
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        }
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
       // $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
       // $(this).addClass("active");    
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
             // $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })
    $(document).ready(function(){
        if($('.responsive-nav').length){
            if($('#p-detail-tabs').length){
                $('#p-detail-tabs').append($('.hidden-links').html())
            }
        }
    })
}

function removeDiacritics(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

$(document).on('click', '.chooseSizes', function(){
    var urlToLoad = $(this).attr('data-url');
    $.get(urlToLoad, function(data) {
        var $html = $('<div>').html(data);
        var $about = $html.find('[itemprop="about"]');
        var content;
        if ($about.length) {
            content = $about.html();
           
        } else {
            var $newsItemDetailText = $html.find('.news-item-detail .text');
            var content = $newsItemDetailText.html();
           
            
        }
        $.colorbox({
            html: '<div class="sizesContent">'+content+'</div>',
            width: 1200,
            maxWidth: "95%",
            height: 800,
            maxHeight: "95%",
            className: "chooseSize",
            onComplete: function() {
                $('.chooseSize ul').each(function(){
                    $(this).attr('data-list', $(this).find('li').length)
                })
            },
        });
    });
});